import SC from "./style";
import CustomBreadcrumb from "components/CustomBreadcrumb";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import JournalSearchInterface from "./JournalSearchInterface";
import OccupantSearchInterface from "./OccupantSearchInterface";
import FileSearchInterface from "./FileSearchInterface";
import AddressBookSearchInterface from "./AddressBookSearchInterface";

const AdvancedSearch = () => {
  const [activeTab, setActiveTab] = useState("1");
  const location = useLocation();
  const navigate = useNavigate();
  const accessControlData = useSelector(
          (state) => state?.accessControlData?.data || []
  );

  // On mount, read tab from URL
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get("tab");
    if (tab) setActiveTab(tab);
  }, []);

  // When tab changes, update URL param
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    params.set("tab", activeTab);
    navigate({ search: params.toString() }, { replace: true });
  }, [activeTab]);

  const currentProject = useSelector(
    (state) => state?.currentProject?.data || []
  );
  const filterSessionKey = `${currentProject.id}-${activeTab}-latestSearchFilter`;
  const tabs = [
    { id: "1", value: "Files" },
    { id: "2", value: "Journal" },
    { id: "4", value: "Address Book" },
    { id: "3", value: "Occupant" }
    
  ];
  const filteredTabs =
  accessControlData?.canAccessInteractiveSearch === 1
    ? tabs
    : tabs.filter(tab => tab.id !== "4");

  return (
    <>
      <CustomBreadcrumb />
      <SC.SearchSummaryContainer>
        <SC.SummaryContainer>
          <SC.QuickSearchSection>
            <SC.QuickSearchLabel>Quick Search Across</SC.QuickSearchLabel>
            <div
              style={{
                display: "inline-block",
                borderRadius: "8px",
                border: "1px solid #e5e7eb",
                padding: "8px",
                background: "#fff",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.08)",
              }}
            >
              <SC.TabContainer>
                {filteredTabs.map((tab) => (
                  <SC.Tab
                    key={tab.id}
                    active={activeTab === tab.id}
                    onClick={() => setActiveTab(tab.id)}
                  >
                    {tab.value}
                  </SC.Tab>
                ))}
              </SC.TabContainer>
            </div>
          </SC.QuickSearchSection>

          {activeTab === "1" && (
            <>
              <FileSearchInterface
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                filterSessionKey={filterSessionKey}
              />
            </>
          )}

          {activeTab === "2" && (
            <>
              <JournalSearchInterface
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                filterSessionKey={filterSessionKey}
              />
            </>
          )}
          {activeTab === "3" && (
            <>
              <OccupantSearchInterface
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                filterSessionKey={filterSessionKey}
              />
            </>
          )}
          {activeTab === "4" && (
            <>
              <AddressBookSearchInterface
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                filterSessionKey={filterSessionKey}
              />
            </>
          )}
        </SC.SummaryContainer>
      </SC.SearchSummaryContainer>
    </>
  );
};

export default AdvancedSearch;
